import { useEffect, useState } from "react";
import { isAdminUser } from "../lib/auth";
import { supabase } from "../lib/supabaseClient";

export function useIsAdmin() {
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        const run = async (user) => {
            if (!user) {
                mounted && setIsAdmin(false);
                mounted && setLoading(false);
                return;
            }

            const ok = await isAdminUser();
            mounted && setIsAdmin(ok);
            mounted && setLoading(false);
        };

        supabase.auth.getSession().then(({ data }) => {
            run(data.session?.user ?? null);
        });

        const { data: sub } = supabase.auth.onAuthStateChange(
            (_event, session) => {
                setLoading(true);
                run(session?.user ?? null);
            },
        );

        return () => {
            mounted = false;
            sub.subscription.unsubscribe();
        };
    }, []);

    return { isAdmin, loading };
}
